import {
  TableColumns,
  TableFilterTab,
} from '../../../../../ui-components/lib/table/table.model';
import { ActionList } from '../../../../common/models/action-list.model';

export const WORKFLOW_CONFIGURATIONS_COLUMNS: TableColumns[] = [
  { header: '' },
  {
    header: 'workflow_configurations_screen_workflow_name_header_title',
    showViewIcon: true,
  },
  {
    header: 'workflow_configurations_screen_workflow_type_header_title',
  },
  {
    header: 'workflow_configurations_screen_workflow_steps_header_title',
  },
  {
    header: 'workflow_configurations_screen_workflow_sla_header_title',
  },
  { header: '' },
];

export const WORKFLOW_CONFIGURATIONS_COLUMNS_WITH_KIND: TableColumns[] = [
  { header: '' },
  {
    header: 'workflow_configurations_screen_workflow_name_header_title',
    showViewIcon: true,
  },
  {
    header: 'workflow_configurations_screen_workflow_kind_header_title',
  },
  {
    header: 'workflow_configurations_screen_workflow_type_header_title',
  },
  {
    header: 'workflow_configurations_screen_workflow_steps_header_title',
  },
  {
    header: 'workflow_configurations_screen_workflow_sla_header_title',
  },
  {
    header: 'workflow_configurations_screen_workflow_status_header_title',
  },
  { header: '' },
];

export const WORKFLOW_CONFIGURATIONS_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const WORKFLOW_CONFIGURATIONS_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
];

export const CUSTOM_WORKFLOW_ICON_UPLOAD_LABELS = {
  placeholder: 'upload_files_placeholder',
  singleFileAttachedLabel: 'upload_files_single_file_attached_label',
  multipleFilesAttachedLabel: 'upload_files_multiple_files_attached_label',
  addMoreLabel: 'upload_files_add_more_label',
  attachmentsTitle: 'upload_files_attachments_title',
  fileUploadTitle: 'upload_files_file_upload_title',
  dragAndDropLabel: 'upload_files_drag_and_drop_label',
  orLabel: 'upload_files_or_label',
  uploadFromComputerLabel: 'upload_files_upload_from_computer_label',
  maxSizeLabel: 'upload_files_max_size_label',
  perFileLabel: 'upload_files_per_file_label',
  maxFilesLimitLabel: 'upload_files_max_files_limit_label',
  cancelButtonLabel: 'upload_files_cancel_button_label',
  continueButtonLabel: 'upload_files_continue_button_label',
  singleFileUploadedLabel: 'upload_files_single_file_uploaded_label',
  multipleFilesUploadedLabel: 'upload_files_multiple_files_uploaded_label',
  singleFileLabel: 'upload_files_single_file_label',
  multipleFilesLabel: 'upload_files_multiple_files_label',
  allFormatsAcceptedLabel: 'upload_files_all_formats_accepted_label',
  acceptedFormatLabel: 'upload_files_accepted_format_label',
  acceptedFormatsLabel: 'upload_files_accepted_formats_label',
  uploadedLabel: 'upload_files_uploaded_label',
  deleteWarningPopupTitle: 'custom_workflow_icon_warning_popup_title',
  deleteWarningPopupDeclaimerMessage:
    'upload_image_warning_popup_declaimer_message',
  deleteWarningPopupCancelButton: 'upload_image_warning_popup_cancel_button',
  deleteWarningPopupContinueButton: 'upload_image_warning_popup_delete_button',
} as const;
